import { Stack, Box } from "@mui/material";
import AdvancedLazyLoadSection from "../components/AdvancedLazyLoadSection";
import Header from "../components/Header";
import {
  BigMissionSectionLazy,
  BotelDeepDiveSectionLazy,
  BotelImageSectionLazy,
  CabinSuiteSectionLazy,
  Earn24_7SectionLazy,
  FoundersClubSectionLazy,
  HeroStoryMomentLazy,
  HeroStoryMomentVideosLazy,
  HostPartnerEarningsSectionLazy,
  ImageCardsCarouselLazy,
  PreSaleSectionLazy,
  PreSaleWorksSectionLazy,
  ProblemSolutionSectionLazy,
  ReferralRewardsSectionLazy,
  TrustedSecuritySectionLazy,
  WaitlistSectionLazy,
  JoinFoundersClubLazy,
  CtaBottomLazy,
  BotelSocialFooterLazy,
} from "../components/lazy";
const LandingPage = () => {
  return (
    <Stack
      sx={{
        backgroundColor: "#fff",
        minHeight: "100vh",
        overflowX: "hidden",
      }}
    >
      <Stack
        direction='column'
        spacing={4}
        sx={{
          backgroundColor: "#fff",
          minHeight: "100vh",
          // px: { xs: 2, sm: 3, md: 3 },
          pt: { xs: 7, sm: 8, md: 0 }, // Add top padding to account for fixed header
        }}
      >
        <Header />

        <AdvancedLazyLoadSection
          height='600px'
          rootMargin='100px'
          sectionName='Botel Image Section'
          preload={true}
        >
          <BotelImageSectionLazy />
        </AdvancedLazyLoadSection>

        <AdvancedLazyLoadSection
          height='600px'
          rootMargin='100px'
          sectionName='Pre-Sale Section'
          preload={true}
        >
          <PreSaleSectionLazy />
        </AdvancedLazyLoadSection>

        {/* Always-present anchors for header navigation (offset for fixed header) */}
        <Box id='earn24-7-section' sx={{ scrollMarginTop: { xs: '64px', sm: '72px', md: '80px' } }} />
        <AdvancedLazyLoadSection
          height='800px'
          rootMargin='100px'
          sectionName='Earn 24/7 Section'
          preload={true}
        >
          <Earn24_7SectionLazy />
        </AdvancedLazyLoadSection>

        <AdvancedLazyLoadSection
          height='800px'
          rootMargin='100px'
          sectionName='Cabin Suite Section'
          preload={true}
        >
          <CabinSuiteSectionLazy />
        </AdvancedLazyLoadSection>

        <Box id='security-section' sx={{ scrollMarginTop: { xs: '64px', sm: '72px', md: '80px' } }} />
        <AdvancedLazyLoadSection
          height='600px'
          rootMargin='100px'
          sectionName='Trusted Security Section'
          preload={true}
        >
          <TrustedSecuritySectionLazy />
        </AdvancedLazyLoadSection>

        {/* <AdvancedLazyLoadSection
          height='800px'
          rootMargin='100px'
          sectionName='Founders Club Section'
          preload={true}
        >
          <FoundersClubSectionLazy />
        </AdvancedLazyLoadSection> */}

        <Box id='presale-works-section' sx={{ scrollMarginTop: { xs: '64px', sm: '72px', md: '80px' } }} />
        <AdvancedLazyLoadSection
          height='600px'
          rootMargin='100px'
          sectionName='Pre-Sale Works Section'
          preload={true}
        >
          <PreSaleWorksSectionLazy />
        </AdvancedLazyLoadSection>

        <Box id='join-founders-club-section' sx={{ scrollMarginTop: { xs: '64px', sm: '72px', md: '80px' } }} />
        <AdvancedLazyLoadSection
          height='600px'
          rootMargin='100px'
          sectionName='Join Founders Club Section'
          preload={true}
        >
          <JoinFoundersClubLazy />
        </AdvancedLazyLoadSection>

        <AdvancedLazyLoadSection
          height='600px'
          rootMargin='100px'
          sectionName='Cta Bottom Section'
          preload={true}
        >
          <CtaBottomLazy />
        </AdvancedLazyLoadSection>

        <AdvancedLazyLoadSection
          height='600px'
          rootMargin='100px'
          sectionName='Botel Social Footer Section'
          preload={true}
        >
          <BotelSocialFooterLazy />
        </AdvancedLazyLoadSection>
      </Stack>
    </Stack>
  );
};

export default LandingPage;
